<template>
	<a v-if="adv" :href="adv.link" target="_blank" class="animate-fade @container block w-full" rel="nofollow noopener">
		<Card content-class="p-0!" :bordered class="relative overflow-hidden" embedded>
			<img
				:src="adv.image_mobile"
				:alt="adv.space_name"
				class="block w-full"
				:class="[mobileClass, { 'border-b-2 border-red-500': debug }]"
				loading="lazy"
			/>
			<img
				:src="adv.image_tablet"
				:alt="adv.space_name"
				class="w-full"
				:class="[tabletClass, { 'border-b-2 border-green-500': debug }]"
				loading="lazy"
			/>
			<img
				:src="adv.image_desktop"
				:alt="adv.space_name"
				class="w-full"
				:class="[desktopClass, { 'border-b-2 border-blue-500': debug }]"
				loading="lazy"
			/>
		</Card>
	</a>
</template>

<script setup lang="ts">
import type { CardSize } from "naive-ui"
import type { AdvSpaceName } from "@/types/adv"
import { computed, watch } from "vue"
import Card from "@/components/common/Card.vue"
import { useStaticStore } from "@/stores/static"

const {
	spaceName,
	bordered = true,
	compact = false
} = defineProps<{
	spaceName: AdvSpaceName
	size: CardSize
	bordered?: boolean
	debug?: boolean
	compact?: boolean
}>()

const emit = defineEmits<{
	(e: "has-adv", value: boolean): void
}>()

const staticStore = useStaticStore()

const adv = computed(() => staticStore.adv.find(adv => adv.space_name === spaceName))

const mobileClass = computed(() => (compact ? "@lg:hidden" : "@2xl:hidden"))
const tabletClass = computed(() => (compact ? "hidden @lg:block @3xl:hidden" : "hidden @2xl:block @4xl:hidden"))
const desktopClass = computed(() => (compact ? "hidden @3xl:block" : "hidden @4xl:block"))

watch(
	adv,
	() => {
		emit("has-adv", !!adv.value)
	},
	{ immediate: true }
)
</script>
